export const PROCESSING_DRIVER_NPS = "PROCESSING_DRIVER_NPS";
export const PROCESSING_BULK_DRIVER_NPS = "PROCESSING_BULK_DRIVER_NPS";
export const GET_DRIVER_NPS = "GET_DRIVER_NPS";
export const CREATE_DRIVER_NPS = "CREATE_DRIVER_NPS";
export const DELETE_DRIVER_NPS = "DELETE_DRIVER_NPS";
